import React, { useEffect, useState } from "react";
import styled from "styled-components";
import ScoreWheel from "components/ScoreWheel";
import { useStepper } from "Stepper";
import Heading from "components/Heading";
import roundDownToNearest10 from "utils/roundDownToNearest10";
import config from "config";
import { ReactComponent as IconCheck } from "assets/icons/checkmark.svg";
import { colors } from "styles";

function GettingStarted() {
  const { next, getDefault } = useStepper();
  const currentScore = getDefault("currentScore");
  const { simulatedScore, selectedOptions } = getDefault("recommendations");
  const [displayedScore, setDisplayedScore] = useState(currentScore);
  const [displayedOptions, setDisplayedOptions] = useState([]);
  const [status, setStatus] = useState("Cargando...");
  const increaseBy = roundDownToNearest10(
    (simulatedScore - currentScore) / selectedOptions.length
  );

  useEffect(() => {
    selectedOptions.forEach((opt, i) => {
      const isLast = i === selectedOptions.length - 1;
      setTimeout(() => {
        setDisplayedScore((current) =>
          isLast ? simulatedScore : current + increaseBy
        );
        setDisplayedOptions((opts) => [
          ...opts,
          config.recommendations.find((rec) => rec.id === opt),
        ]);

        if (isLast) {
          setStatus("Processing...");

          setTimeout(() => {
            next();
          }, 1000 * 2);
        }
      }, 1000 * (i + 1));
    });
  }, []);

  return (
    <>
      <div className="text-center">
        <div style={{ paddingBottom: 20 }}>
          <ScoreWheel
            $size="large"
            score={displayedScore}
            disabled
            label={status}
          />
        </div>

        <Heading
          title={`Usted está a solo pasos de lograr un Crédito Excelente`}
        />

        <ul>
          {displayedOptions.map((opt) => (
            <Item key={opt.id}>
              <div>
                <IconCheck width="15" />
              </div>
              {opt.bodyFuture}
            </Item>
          ))}
        </ul>
      </div>
    </>
  );
}

export default GettingStarted;

const Item = styled.li`
  display: flex;
  text-align: left;
  padding: 10px;
  align-items: start;
  font-size: 1.2em;

  animation-name: slidein;
  animation-duration: 2s;

  @keyframes slidein {
    from {
      opacity: 0;
      transform: translateY(10px);
    }

    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  svg {
    margin: 3px 10px 0 0;
    path {
      fill: ${colors.green};
    }
  }
`;
